import React from 'react'
import type { Review as ReviewType } from '../supplier_show/prop_shapes/review'
import { newEntryPath } from '../routes/path'
import { PopoverAutoClose } from 'components/common/popover/PopoverAutoClose'

interface ReviewActionsMenuProps {
  review: ReviewType
  canReportAbuse: boolean
}

export function ReviewActionsMenu ({ review, canReportAbuse }: ReviewActionsMenuProps): React.ReactElement {
  return canReportAbuse
    ? (
      <PopoverAutoClose
        placement='bottom-end'
        anchor={
          <button
            type='button'
            className='unstyled-tip-label review-actions-trigger'
            aria-label='Review Actions'
          >
            <i className='fa-regular fa-ellipsis-vertical' aria-hidden />
          </button>
        }
      >
        <a
          href={newEntryPath(review.id, 'Review')}
          className='pro-text-xs unstyled-tip-label review-actions-menu-item'
          data-remote='true'
        >
          Report Review
        </a>
      </PopoverAutoClose>
      )
    : <></>
}
